export default "__VITE_ASSET__CGcWvija__"